<template>
    <div class="mb-3">
         <div class="mb-3">
            <div class="form-row">
                <radio-element v-model="block.expanded" :error="getError('expanded')" label="Expanded" :name="'expanded-'+blockIndex" :required="true" :options="options"></radio-element>
            </div>

            <div class="form-row">
                <radio-element v-model="block.show_year_of_birth" :error="getError('show_year_of_birth')" label="Show year of birth" :name="'show_year_of_birth-'+blockIndex" :required="true" :options="options"></radio-element>
            </div>

            <div class="form-row">
                <input-element v-model="block.email" :error="getError('email')" label="Email" placeholder="Semicolon separated" :name="'email-'+blockIndex" :required="true"></input-element>
            </div>

            <a href @click.prevent="clickThemes">Themes</a>

            <template v-if="toggleThemes">
                <p v-if="themes.length == 0">No themes available yet!</p>

                <template v-if="themes.length > 0">
                    <div class="form-row" v-for="(theme, index) in  themes" :key="index">
                        <input-element v-model="block.themes[theme.id]" :error="errorTheme(theme.id)" :label="theme.name" placeholder="Semicolon separated" :name="theme.name+'-'+theme.id+'-'+blockIndex" :required="false"></input-element>
                    </div>
                </template>
            </template>
        </div>

        <div class="tab-content">
            <ul class="nav nav-tabs mb-3" role="tablist">
                <li class="nav-item" v-for="(lang, index) in getTranslations" :key="index">
                    <a
                        :aria-selected="active(lang) ? 'true' : 'false'"
                        :id="blockIndex+'-'+lang+'-'+index+'-tab'"
                        :href="'#tab-'+blockIndex+'-'+lang+'-'+index"
                        :aria-controls="'tab-'+blockIndex+'-'+lang+'-'+index"
                        data-toggle="tab"
                        role="tab"
                        class="nav-link"
                        :class="[getErrorTab(lang) ? 'text-danger font-weight-bolder': '', active(lang) ? 'active' : '']"
                        >{{ lang.toUpperCase() }}</a>
                </li>
            </ul>

            <div
                :id="'tab-'+blockIndex+'-'+lang+'-'+index"
                role="tabpanel"
                :aria-labelledby="+blockIndex+'-'+lang+'-'+index+'-tab'"
                class="tab-pane fade"
                :class="active(lang) ? 'show active' : ''"
                v-for="(lang, index) in getTranslations" :key="index"
                >
                <div class="form-row">
                    <input-element v-model="block.translations[lang].title" :error="getErrorTranslation(lang, 'title')" label="Title" :name="'title-'+blockIndex+'-'+lang+'-'+index" :required="true"></input-element>
                </div>

                <div class="form-row">
                    <textarea-element  v-model="block.translations[lang].content" :error="getErrorTranslation(lang, 'content')" label="Content" :name="'content-'+blockIndex+'-'+lang+'-'+index" :required="false"></textarea-element>
                </div>

                <div class="form-row">
                    <input-element v-model="block.translations[lang].button_txt" :error="getErrorTranslation(lang, 'button_txt')" label="Button text" :name="'button_txt-'+blockIndex+'-'+lang+'-'+index" :required="true"></input-element>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputElement from "../form-elements/Input.vue";
import TextareaElement from "../form-elements/Textarea.vue";
import RadioElement from "../form-elements/Radio.vue";
import Options from "../..//mixins/Options.js"
import Error from "../../mixins/Error.js"
import ErrorTab from "../../mixins/ErrorTab.js"
import ErrorTranslation from "../../mixins/ErrorTranslation.js"
import GetTranslations from "../../mixins/GetTranslations.js"
import Active from "../../mixins/Active.js"

export default {
    components: {
        InputElement,
        TextareaElement,
        RadioElement,
    },
    mixins: [Options, Error, ErrorTab, ErrorTranslation, GetTranslations, Active],
    props: {
        block:Object,
        index:Number,
        locale:String,
    },
    computed: {
        themes() {
            return this.$store.getters.getThemesData;
        },
        themeIds() {
            return Object.keys(this.themes);
        }
    },
    data() {
        return {
            blockIndex: this.index,
            toggleThemes: false
        }
    },
    mounted() {
        if(this.block?.errors?.themes) {
            this.toggleThemes = true;//after force refresh
        }
    },
    methods: {
        clickThemes() {
            this.toggleThemes = ! this.toggleThemes;
        },
        errorTheme(id) {
            return this.block?.errors?.themes?.[id];
        }
    }
}
</script>